"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = capitalize;
exports.capitalizeAll = capitalizeAll;
/**
 * Capitalizes the first letter of the first non-space character in a string,
 * while preserving leading and trailing spaces.
 *
 * @param {string} [input=null] - The input string to be capitalized.
 * @returns {string | null} - The capitalized string, or null if the input is not a string or is empty.
 */
function capitalize(input = null) {
    var _a, _b;
    if (typeof input !== 'string') {
        return null;
    }
    // Capture leading and trailing spaces
    const leadingSpaces = ((_a = input.match(/^\s*/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
    const trailingSpaces = ((_b = input.match(/\s*$/)) === null || _b === void 0 ? void 0 : _b[0]) || '';
    const trimmedInput = input.trim();
    // Capitalize the first letter of the trimmed input and recombine with spaces
    return leadingSpaces + trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1) + trailingSpaces;
}
/**
 * Capitalizes the first letter of each word in a string,
 * while preserving the original spaces within the string.
 *
 * @param {string} [input=null] - The input string to be capitalized.
 * @returns {string | null} - The string with each word capitalized, or null if the input is not a string or is empty.
 */
function capitalizeAll(input) {
    if (typeof input !== 'string') {
        return null;
    }
    return input
        .split(' ')
        .map(capitalize)
        .join(' ');
}
//# sourceMappingURL=utility.js.map